var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.indirizzo
    ? _c(
        "div",
        [
          _c("stepheader", { attrs: { step: _vm.step } }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "body current",
              attrs: {
                id: "wizard2-p-0",
                role: "tabpanel",
                "aria-labelledby": "wizard2-h-0",
                "aria-hidden": "false",
              },
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm.indirizzi.length > 1
                  ? _c("div", { staticClass: "btn-group mt-2 mb-2" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "dropdown-menu",
                          attrs: { role: "menu" },
                        },
                        _vm._l(_vm.indirizzi, function (item) {
                          return _c("li", [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.setIndirizzo(item)
                                  },
                                },
                              },
                              [
                                _c("p", [_vm._v(_vm._s(item.cognomeNome))]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.indirizzo) +
                                      " " +
                                      _vm._s(item.cap) +
                                      " " +
                                      _vm._s(item.comune) +
                                      " " +
                                      _vm._s(item.provincia)
                                  ),
                                ]),
                              ]
                            ),
                          ])
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "denominazione" },
                    },
                    [_vm._v("Presso: *")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indirizzo.denominazione,
                        expression: "indirizzo.denominazione",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", id: "denominazione" },
                    domProps: { value: _vm.indirizzo.denominazione },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.indirizzo,
                          "denominazione",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "denominazione" },
                    },
                    [_vm._v("Nome Citofono:")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indirizzo.citofono,
                        expression: "indirizzo.citofono",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", id: "citofono" },
                    domProps: { value: _vm.indirizzo.citofono },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.indirizzo, "citofono", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                false
                  ? _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "referente" },
                        },
                        [_vm._v("Referente:")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.indirizzo.referente,
                            expression: "indirizzo.referente",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "referente" },
                        domProps: { value: _vm.indirizzo.referente },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.indirizzo,
                              "referente",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6" }, [
                  _c(
                    "label",
                    { staticClass: "form-label", attrs: { for: "telefono" } },
                    [_vm._v("Telefono: *")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indirizzo.telefono,
                        expression: "indirizzo.telefono",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "tel", id: "telefono" },
                    domProps: { value: _vm.indirizzo.telefono },
                    on: {
                      keypress: function ($event) {
                        return _vm.isNumber($event)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.indirizzo, "telefono", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6" }, [
                  _c(
                    "label",
                    { staticClass: "form-label", attrs: { for: "cellulare" } },
                    [_vm._v("Cellulare: *")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indirizzo.cellulare,
                        expression: "indirizzo.cellulare",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "tel", id: "cellulare" },
                    domProps: { value: _vm.indirizzo.cellulare },
                    on: {
                      keypress: function ($event) {
                        return _vm.isNumber($event)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.indirizzo,
                          "cellulare",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "label",
                    { staticClass: "form-label", attrs: { for: "indirizzo" } },
                    [_vm._v("Indirizzo: *")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indirizzo.indirizzo,
                        expression: "indirizzo.indirizzo",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", id: "indirizzo" },
                    domProps: { value: _vm.indirizzo.indirizzo },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.indirizzo,
                          "indirizzo",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-3 col-lg-3 col-xl-3" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "Indirizzo" },
                      },
                      [_vm._v("Regione")]
                    ),
                    _vm._v(" "),
                    _c("v-select", {
                      attrs: {
                        options: _vm.regioni,
                        label: "nomeRegione",
                        reduce: (x) => x.idRegione,
                        placeholder: "Scegli un regione",
                      },
                      on: { input: _vm.loadProvince },
                      model: {
                        value: _vm.indirizzo.idRegione,
                        callback: function ($$v) {
                          _vm.$set(_vm.indirizzo, "idRegione", $$v)
                        },
                        expression: "indirizzo.idRegione",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3 col-lg-3 col-xl-3" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "Indirizzo" },
                      },
                      [_vm._v("Provincia")]
                    ),
                    _vm._v(" "),
                    _c("v-select", {
                      attrs: {
                        options: _vm.province,
                        disabled: _vm.province.length == 0,
                        label: "nomeProvincia",
                        reduce: (x) => x.idProvincia,
                        placeholder: "Scegli una provincia",
                      },
                      on: { input: _vm.loadComuni },
                      model: {
                        value: _vm.indirizzo.idProvincia,
                        callback: function ($$v) {
                          _vm.$set(_vm.indirizzo, "idProvincia", $$v)
                        },
                        expression: "indirizzo.idProvincia",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3 col-lg-3 col-xl-3" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "Indirizzo" },
                      },
                      [_vm._v("Comune")]
                    ),
                    _vm._v(" "),
                    _c("v-select", {
                      attrs: {
                        options: _vm.comuni,
                        disabled: _vm.comuni.length == 0,
                        label: "nomeComune",
                        reduce: (x) => x.idComune,
                        placeholder: "Scegli un comune",
                      },
                      on: { input: _vm.loadCap },
                      model: {
                        value: _vm.indirizzo.idComune,
                        callback: function ($$v) {
                          _vm.$set(_vm.indirizzo, "idComune", $$v)
                        },
                        expression: "indirizzo.idComune",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3 col-lg-3 col-xl-3" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "Indirizzo" },
                      },
                      [_vm._v("Cap")]
                    ),
                    _vm._v(" "),
                    _c("v-select", {
                      attrs: {
                        options: _vm.cap,
                        disabled: _vm.cap.length == 0,
                        label: "cap",
                        reduce: (x) => x.idCap,
                        placeholder: "Scegli un cap",
                      },
                      model: {
                        value: _vm.indirizzo.idCap,
                        callback: function ($$v) {
                          _vm.$set(_vm.indirizzo, "idCap", $$v)
                        },
                        expression: "indirizzo.idCap",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("buttons", {
            attrs: { buttons: _vm.step.buttons },
            on: { action: _vm.fireaction },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-outline-default dropdown-toggle",
        attrs: {
          type: "button",
          "data-bs-toggle": "dropdown",
          "aria-expanded": "false",
        },
      },
      [
        _vm._v(
          "\n            Seleziona un'indirizzo oppure modifica qui sotto "
        ),
        _c("span", { staticClass: "caret" }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }